{
	"mode": {
		"AIR": "Air",
		"LAND": "Land",
		"SEA": "Sea"
	},
	"time": {
		"zoneNote": "Times are {{zone}}, the Games' time. Hover a time to see yours."
	},
	"panel": {
		"personMeta": "{{number}} · {{org}} · {{category}}"
	},
	"override": {
		"title": "Flight times",
		"trackedNow": "Updated automatically from flight data.",
		"manualNow": "Set by hand. Automatic updates are paused.",
		"open": "Change times or status",
		"resume": "Resume automatic updates",
		"resumed": "Automatic updates resumed",
		"status": "Status",
		"timeArrival": "Expected landing ({{zone}})",
		"timeDeparture": "Expected take-off ({{zone}})",
		"date": "Date",
		"time": "Time",
		"timeHint": "Everyone on this flight moves with it. Landed or departed: enter when it happened.",
		"reason": "Reason (optional)",
		"reasonHint": "Recorded with this change, for the audit.",
		"cancel": "Cancel",
		"save": "Save flight",
		"saved": "{{flight}} updated",
		"failed": "Couldn't update the flight"
	},
	"add": {
		"doneTitle": "Travel added",
		"search": "Name or Card Number",
		"organisation": "Organisation",
		"status": "Record status",
		"any": "All",
		"anyOpen": "Any open record",
		"onlyMissingArrival": "Only records without an arrival",
		"onlyMissingDeparture": "Only records without a departure",
		"filter": "Filter",
		"reset": "Reset",
		"selectShown": "Select all shown",
		"matching_one": "{{n}} record matches",
		"matching_other": "{{n}} records match",
		"loadMore": "Load more",
		"loadFailed": "Couldn't load the records. Close this and try again.",
		"noRecords": "No records match. Change the filters, or untick \"Only records without…\".",
		"selected_one": "{{n}} record selected",
		"selected_other": "{{n}} records selected",
		"tooMany": "Pick at most {{max}} records at a time",
		"next": "Next: travel details",
		"back": "Records",
		"nextDeparture": "Next: departure",
		"cancel": "Cancel",
		"close": "Done",
		"replaceArrival": "Replace an arrival already entered",
		"replaceDeparture": "Replace a departure already entered",
		"replaceHint": "Off: records that already have one keep it and are listed after saving.",
		"saveArrival_one": "Add arrival",
		"saveArrival_other": "Add arrival to {{n}} records",
		"saveDeparture_one": "Add departure",
		"saveDeparture_other": "Add departure to {{n}} records",
		"savedArrival_one": "Arrival saved on {{n}} record",
		"savedArrival_other": "Arrival saved on {{n}} records",
		"savedDeparture_one": "Departure saved on {{n}} record",
		"savedDeparture_other": "Departure saved on {{n}} records",
		"refusedTitle_one": "{{n}} record was left unchanged",
		"refusedTitle_other": "{{n}} records were left unchanged",
		"failed": "Couldn't add the travel",
		"replaceThese_one": "Replace on this {{n}} record",
		"replaceThese_other": "Replace on these {{n}} records",
		"replaceTheseHintArrival": "Overwrites the arrival these records already have with this one.",
		"replaceTheseHintDeparture": "Overwrites the departure these records already have with this one.",
		"replaced_one": "Replaced on {{n}} record",
		"replaced_other": "Replaced on {{n}} records",
		"arrival": "Add arrival",
		"departure": "Add departure",
		"pickSubtitle": "Pick who it's for",
		"forOne": "for {{name}}",
		"forMany_one": "for {{n}} record",
		"forMany_other": "for {{n}} records",
		"stepWho": "Who",
		"stepSkipped": "Skipped",
		"steps": "Steps",
		"arrivalHeading": "Arrival",
		"departureHeading": "Departure",
		"noDeparture": "No departure date yet",
		"noDepartureHint": "Add the departure later from Arrival & Departure, once the return ticket is bought.",
		"saveBoth_one": "Add arrival & departure",
		"saveBoth_other": "Add arrival & departure to {{n}} records",
		"replaceBoth": "Replace travel already entered",
		"departureFailed": "The departure wasn't saved"
	},
	"refusal": {
		"not_in_scope": "Not in your records",
		"permission": "You can't change this record's travel",
		"locked": "Record is closed or can no longer be edited",
		"already_set": "Already has one",
		"other": "Not changed"
	},
	"recordsFilter": {
		"missing_arrival": "No arrival",
		"has_arrival": "Has an arrival",
		"missing_departure": "No departure",
		"has_departure": "Has a departure"
	},
	"legForm": {
		"mode": {
			"AIR": "Air",
			"LAND": "Land",
			"SEA": "Sea"
		},
		"field": {
			"mode": "Travel mode",
			"arrivesAt": "Arrives at",
			"leavesFrom": "Leaves from",
			"date": "Date",
			"arrivalTime": "Arrival time ({{zone}})",
			"departureTime": "Departure time ({{zone}})",
			"flight": "Flight no.",
			"coach": "Coach or train no.",
			"ferry": "Ferry or vessel",
			"from": "From (airport or city)",
			"to": "To (airport or city)",
			"transferArrival": "Games transfer on arrival",
			"transferDeparture": "Games transfer on departure",
			"remarks": "Remarks",
			"flightDate": "Flight date",
			"flightDateDeparts": "Flight date (departs)",
			"transportType": "Transportation type",
			"transportTypeOther": "Please specify",
			"callSign": "Flight no. or call sign"
		},
		"placeholder": {
			"flight": "e.g. MH 803",
			"coach": "e.g. Coach 1",
			"ferry": "e.g. Batam Fast 2",
			"from": "e.g. Manila",
			"to": "e.g. Manila",
			"fromAirport": "City or airport, e.g. Manila (MNL)",
			"toAirport": "City or airport, e.g. Manila (MNL)",
			"remarks": "Anything the welcome desk should know",
			"transportTypeOther": "e.g. Helicopter",
			"callSign": "Optional"
		},
		"hint": {
			"timeOptional": "Leave it empty if the time isn't known yet.",
			"timeNeedsDate": "Pick the date too, or this time won't be saved.",
			"transferArrival": "From the entry point to their hotel or venue.",
			"transferDeparture": "From their hotel to the entry point."
		},
		"entryPoint": {
			"placeholder": "Select",
			"loading": "Loading…",
			"search": "Search",
			"noneOfMode": "No entry points of this type yet. An administrator adds them in Game Settings → Entry points."
		},
		"flight": {
			"place": "{{name}} ({{code}})",
			"terminal": "{{code}} {{terminal}}",
			"route": "{{from}} → {{to}}",
			"gamesAirportArrival": "Lands at a Games airport",
			"gamesAirportDeparture": "Leaves from a Games airport"
		},
		"lookup": {
			"loading": "Looking up…",
			"miss": {
				"TRACKING_OFF": "Flight tracking is off. Enter the time yourself.",
				"NOT_FOUND": "No flight with this number on that date. Check it, or enter the time yourself.",
				"UNAVAILABLE": "Flight details aren't available right now. Enter the time yourself.",
				"RATE_LIMITED": "Too many flight lookups for now. Enter the time yourself.",
				"NEED_DATE": "Pick the date to look this flight up.",
				"UNREADABLE": "Not a flight number we can look up, like MH 803. It's saved as typed."
			},
			"button": "Look up flight"
		},
		"status": {
			"SCHEDULED": "Scheduled",
			"DELAYED": "Delayed",
			"DEPARTED": "In the air",
			"LANDED": "Landed",
			"CANCELLED": "Cancelled",
			"DIVERTED": "Diverted",
			"UNKNOWN": "No update"
		},
		"statusHint": {
			"SCHEDULED": "Not departed yet, on time as far as anyone knows",
			"DELAYED": "Running later than scheduled",
			"DEPARTED": "Took off, not landed yet",
			"LANDED": "Has landed",
			"CANCELLED": "Will not fly",
			"DIVERTED": "Landed somewhere else",
			"UNKNOWN": "No word from flight tracking"
		},
		"time": {
			"at": "{{time}} {{zone}}",
			"unknown": "Time not known yet",
			"movedArrival": "now lands {{expected}} {{zone}}, scheduled {{scheduled}}",
			"movedDeparture": "now leaves {{expected}} {{zone}}, scheduled {{scheduled}}"
		},
		"validation": {
			"required": "Required",
			"textTooLong": "Too long",
			"dateInvalid": "Enter a valid date",
			"dateTimeInvalid": "Enter a valid date and time",
			"flightInvalid": "Enter a flight number like MH 803",
			"flightOnlyForAir": "Only air travel has a flight",
			"delayWithFlight": "This flight's delay comes from the flight itself",
			"departureBeforeArrival": "Departure must be on or after the arrival date",
			"rangeInvalid": "The end date must be on or after the start date",
			"rangeTooLong_one": "At most {{count}} day",
			"rangeTooLong_other": "At most {{count}} days",
			"idsDuplicate": "A record is listed twice",
			"nothingToChange": "Nothing to change",
			"landedBeforeDeparted": "Landing must be after take-off",
			"codeInvalid": "Use letters, digits, - or _ (at most 20)",
			"nameRequired": "Enter a name",
			"iataInvalid": "Enter a 3-letter IATA code",
			"iataOnlyForAir": "Only an airport has an IATA code",
			"minutesInvalid": "Enter whole minutes within the allowed range",
			"sortOrderInvalid": "Enter a whole number, 0 or more",
			"flightNumberRequired": "Enter the flight number",
			"connectionNeedsLookup": "Find this flight and pick the day it flies",
			"connectionsNeedFlight": "Find the main flight before adding connecting flights",
			"connectionsTooMany_one": "At most {{count}} connecting flight",
			"connectionsTooMany_other": "At most {{count}} connecting flights",
			"connectionsDuplicate": "The same flight is listed twice",
			"connectionRoute": "This flight doesn't leave from the airport the previous flight lands at.",
			"connectionTime": "This flight leaves before the previous flight lands.",
			"transportTypeMismatch": "Pick a type of this travel mode",
			"transportTypeOtherRequired": "Say how they travel"
		},
		"dates": {
			"awaitFlight": "Enter the flight number first",
			"loading": "Finding the days it flies…",
			"pick": "Pick a date",
			"change": "Change",
			"fixed": "This flight's other dates can't be loaded right now.",
			"hintArrival": "The day it takes off. It may land the next day.",
			"prompt": "Enter the flight number. We'll show the days it flies.",
			"pickPrompt": "Pick the day it flies. We'll fill in the time, airport and route.",
			"calendarLabel": "Days {{flight}} flies",
			"legend": "Only the days {{flight}} flies can be picked.",
			"miss": {
				"TRACKING_OFF": "Flight schedules are off. Enter the date and time yourself.",
				"NOT_FOUND": "This flight isn't in the airline schedules. Enter the date and time yourself.",
				"NO_DATES": "This flight doesn't fly during the Games travel window. Check the number, or enter the date and time yourself.",
				"UNAVAILABLE": "Flight schedules aren't available right now. Enter the date and time yourself.",
				"RATE_LIMITED": "Too many flight lookups for now. Enter the date and time yourself.",
				"UNREADABLE": "Not a flight number we can look up, like MH 803. Enter the date and time yourself."
			},
			"notInSchedules": "{{flight}} isn't in the airline schedules between {{from}} and {{to}}. Check the number, or enter the date and time yourself."
		},
		"pickMiss": {
			"notOurAirportArrival": "{{flight}} on {{date}} flies {{from}} → {{to}}. It doesn't arrive at a Games airport ({{airports}}).",
			"notOurAirportDeparture": "{{flight}} on {{date}} flies {{from}} → {{to}}. It doesn't leave from a Games airport ({{airports}}).",
			"place": "{{name}} ({{code}})",
			"unknownPlace": "an unknown airport",
			"notFound": "No {{flight}} on {{date}} after all. Pick another day.",
			"unavailable": "Flight details aren't available right now. Pick the day again in a moment.",
			"rateLimited": "Too many flight lookups for now. Try again later.",
			"enterYourself": "Enter times yourself"
		},
		"transit": {
			"ordinal": {
				"1": "1st flight",
				"2": "2nd flight",
				"3": "3rd flight"
			},
			"finalArrival": "Final flight",
			"add": "Add another connection",
			"remove": "Remove",
			"removeLabel": "Remove the {{flight}}",
			"change": "Change at {{place}} · {{duration}}",
			"changeNoTime": "Change at {{place}}",
			"duration": "{{hours}} h {{minutes}} min",
			"durationMinutes": "{{minutes}} min",
			"atRisk": "Connection at risk",
			"atRiskHint_one": "Less than {{count}} minute to change planes, or a connecting flight is cancelled or diverted",
			"atRiskHint_other": "Less than {{count}} minutes to change planes, or a connecting flight is cancelled or diverted",
			"routeMismatch": "This flight lands at {{lands}}, but the next one leaves from {{leaves}}.",
			"timeOrder": "The next flight leaves before this one lands.",
			"via": "via {{airports}}",
			"prompt": "Enter the flight number, then pick the day it flies.",
			"miss": {
				"TRACKING_OFF": "Flight schedules are off, so connecting flights can't be added. Remove this flight and note it in Remarks.",
				"NOT_FOUND": "{{flight}} isn't in the airline schedules, so it can't be added as a connection. Check the number, or remove this flight and note it in Remarks.",
				"UNAVAILABLE": "Flight schedules aren't available right now. Search again in a moment.",
				"UNREADABLE": "Not a flight number we can look up, like MH 803."
			},
			"addFirst": "Add a connecting flight",
			"notOurAirportHintArrival": "Add it as a connecting flight, then enter the flight that lands at a Games airport.",
			"notOurAirportHintDeparture": "Add it as a connecting flight, then enter the flight that leaves from a Games airport."
		},
		"addRemark": "Add a remark",
		"transportType": {
			"COMMERCIAL_FLIGHT": "Commercial flight",
			"PRIVATE_CARGO": "Private / cargo",
			"CAR": "Car",
			"TRAIN": "Train",
			"CRUISE": "Cruise",
			"COMMERCIAL_VESSEL": "Commercial vessel",
			"OTHER": "Others (please specify)"
		}
	},
	"delay": {
		"title": "Delay",
		"onSchedule": "On schedule.",
		"delayedNow": "Delayed by hand for everyone on this trip.",
		"set": "Set delay",
		"change": "Change delay",
		"clear": "Clear delay",
		"timeArrival": "New arrival time ({{zone}})",
		"timeDeparture": "New departure time ({{zone}})",
		"date": "Date",
		"time": "Time",
		"applies_one": "Applies to the {{n}} person on this trip.",
		"applies_other": "Applies to all {{n}} people on this trip.",
		"reason": "Reason (optional)",
		"reasonHint": "Recorded with this change on each record, for the audit.",
		"cancel": "Cancel",
		"save": "Save delay",
		"saved_one": "Delay saved for {{n}} person",
		"saved_other": "Delay saved for {{n}} people",
		"cleared_one": "Delay cleared for {{n}} person",
		"cleared_other": "Delay cleared for {{n}} people",
		"unchanged": "Nothing changed: everyone already had this time.",
		"failed": "Couldn't save the delay",
		"tooMany": "This trip has more than {{max}} people. Narrow the filters (for example by organisation) to delay it in parts.",
		"refusedTitle_one": "{{n}} person was left unchanged",
		"refusedTitle_other": "{{n}} people were left unchanged",
		"dismiss": "Dismiss",
		"clearIntro_one": "{{n}} person goes back to the scheduled time.",
		"clearIntro_other": "All {{n}} people on this trip go back to the scheduled time.",
		"delayedSome_one": "Delayed by hand for {{delayed}} of the {{n}} person on this trip.",
		"delayedSome_other": "Delayed by hand for {{delayed}} of the {{n}} people on this trip."
	},
	"delayRefusal": {
		"not_in_scope": "Not in your records",
		"permission": "You can't change this person's travel",
		"locked": "Record is closed",
		"has_flight": "On a tracked flight: change the flight instead",
		"other": "Not changed"
	},
	"itinerary": {
		"arrival": "Arrival",
		"departure": "Departure",
		"noDate": "No date yet",
		"saved": "Saved",
		"live": "Live flight data",
		"liveHint": "Times come from the flight tracker and update by themselves.",
		"manual": "Typed by hand",
		"manualHint": "Times were typed in and do not update by themselves.",
		"connectIn": "Change planes at {{code}}",
		"entryPoint": "Entry point",
		"terminal": "Terminal {{terminal}}",
		"pickupArrival": "Games transfer meets them",
		"pickupDeparture": "Games transfer to the entry point",
		"noPickup": "No Games transfer",
		"timeUnknown": "Time not known",
		"duration": "{{h}}h {{m}}m",
		"preview": "Itinerary preview"
	},
	"airportPicker": {
		"searching": "Searching airports…",
		"noMatch": "No airport found. What you typed is kept.",
		"failed": "Airports could not be searched. What you typed is kept.",
		"listLabel": "Airports"
	},
	"flightCard": {
		"status": {
			"on_time": "On time",
			"delayed": "Delayed",
			"delayedBy_one": "Delayed {{n}} min",
			"delayedBy_other": "Delayed {{n}} min",
			"departed": "Departed",
			"landed": "Landed",
			"landedAt": "Landed {{time}}",
			"cancelled": "Cancelled",
			"diverted": "Diverted",
			"no_news": "No news",
			"not_tracked": "Not tracked"
		},
		"statusHint": {
			"on_time": "Expected within {{minutes}} minutes of the schedule.",
			"delayed": "Later than scheduled by {{minutes}} minutes or more.",
			"departed": "In the air; the landing time is the estimate.",
			"landed": "On the ground; the times are the actual ones.",
			"cancelled": "The airline cancelled this flight.",
			"diverted": "The flight landed somewhere else.",
			"no_news": "Tracking found nothing about this flight yet.",
			"not_tracked": "No flight on record: the time was typed and nobody updates it."
		},
		"manual": "Manual times",
		"manualHint": "A desk set these times by hand; tracking is paused until it is resumed.",
		"durationM": "{{m}}m",
		"durationH": "{{h}}h",
		"durationHm": "{{h}}h {{m}}m",
		"durationUnknown": "Duration unknown",
		"yourTime": "your time",
		"zoneTyped": "{{zone}} · typed",
		"zoneDay": "{{zone}} · {{day}}",
		"direct": "Direct",
		"typedTime": "Typed time",
		"stops_one": "{{count}} stop · {{airports}}",
		"stops_other": "{{count}} stops · {{airports}}",
		"stopsChange_one": "{{count}} stop · {{airports}} · {{minutes}} min change",
		"stopsChange_other": "{{count}} stops · {{airports}} · {{minutes}} min change",
		"stopsAtRisk_one": "{{count}} stop · {{airports}} · at risk",
		"stopsAtRisk_other": "{{count}} stops · {{airports}} · at risk",
		"otherRoutes_one": "+{{n}} other route",
		"otherRoutes_other": "+{{n}} other routes",
		"noFlight": "No flight on record",
		"scheduledWas": "Scheduled",
		"noTime": "Time not known yet",
		"landsOn": "Lands {{day}}",
		"to": "to",
		"lineTail": "{{duration}} · {{stops}}",
		"lineSub": "{{day}} · {{entry}}",
		"lineSubTyped": "{{day}} · {{entry}} · typed time, not updated",
		"pickup": "Pickup {{time}}",
		"atAirportBy": "At the airport by {{time}}",
		"localNote": "Flight times are local at each airport, with the zone beside them. Other times are {{zone}}, the Games' time.",
		"takeOff": "Take-off: scheduled {{scheduled}} · estimated {{estimated}} · actual {{actual}}",
		"landing": "Landing: scheduled {{scheduled}} · estimated {{estimated}} · actual {{actual}}",
		"path_one": "{{from}} {{departs}} → {{to}} {{arrives}} · via {{via}} · {{n}} person",
		"path_other": "{{from}} {{departs}} → {{to}} {{arrives}} · via {{via}} · {{n}} people",
		"pathChange": "{{minutes}} min change",
		"arrival": "Arrival",
		"departure": "Departure",
		"dirDay": "{{direction}} · {{day}}",
		"guideHeading": "On each flight card"
	}
}
